export default defineNuxtPlugin(nuxtApp => {
  let config = useRuntimeConfig()
  useHead({
    script: [
      {
        src: `https://maps.googleapis.com/maps/api/js?key=${config.public.googleApiKey}&libraries=places`, //&callback=initMap
        async: true,
        defer: true,
      }/*, {
        src: '/scripts/map-init.js',
        async: true,
      }*/,
    ],
  })
}) 
